import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.NEXT_PUBLIC_MIX_PANEL);

export const Mixpanel = mixpanel;
